module.exports = __webpack_public_path__ + "media/images/triangle--up-56cea602288423f28d4310bb564a39b3.png";